(() => {
  const cache = new Map();
  const shard = key => [...key].reduce((n, c) => n + c.charCodeAt(0), 0) % 128;
  async function read(config, key) {
    const n = shard(key);
    if (!cache.has(n)) cache.set(n, fetch(config.urls[n], {credentials: 'omit'}).then(r => {
      if (!r.ok) throw new Error('Navigation unavailable');
      return r.json();
    }));
    return (await cache.get(n))[key];
  }
  function choose(entries, focus) {
    const holderKeys = ['holder', 'bike', 'motor', 'scooter', 'desk', 'tablet-car', 'tablet-holder', 'wireless-holder'];
    const audioKeys = ['audio', 'audio-other', 'earbuds', 'wired', 'headphones', 'speaker', 'mic'];
    const groupOf = e => holderKeys.includes(e[2]) ? 'holder' : audioKeys.includes(e[2]) ? 'audio' : e[3];
    const current = entries.find(e => e[0].split('?')[0] === location.pathname.replace(/\/$/, ''));
    if (current && ['holder', 'audio'].includes(groupOf(current))) focus = groupOf(current);
    const groups = ['case', 'screen', 'charge', 'cable', 'holder', 'audio'];
    const sequence = (groups.includes(focus) ? [focus] : []).concat(groups.filter(g => g !== focus), ['other']);
    const keys = new Set();
    const all = entries.filter(e => e && !keys.has(e[2]) && keys.add(e[2]));
    let result = [];
    for (const group of sequence) {
      const part = all.filter(e => groupOf(e) === group && e[2] !== 'accessories');
      const main = ['cases', 'screen', 'charger', 'cable', 'usbc'];
      part.sort((a, b) => (main.includes(a[2]) ? -1 : 0) - (main.includes(b[2]) ? -1 : 0));
      result.push(...(group === focus ? part : part.slice(0, 1)));
    }
    if (result.length < 12) result.push(...all.filter(e => !result.includes(e) && e[2] !== 'accessories').slice(0, 12 - result.length));
    return result.slice(0, 16).concat(all.filter(e => e[2] === 'accessories').slice(0, 1));
  }
  function icon(key) {
    const paths = {
      'audio-other': '<path d="M8 23v-5a12 12 0 0 1 24 0v5M8 21H5v11h6V21zm24 0h3v11h-6V21zM17 17v10m6-13v16"/>',
      accessories: '<rect x="4" y="4" width="13" height="13" rx="3"/><rect x="23" y="4" width="13" height="13" rx="3"/><rect x="4" y="23" width="13" height="13" rx="3"/><rect x="23" y="23" width="13" height="13" rx="3"/>',
      sleeve: '<rect x="4" y="7" width="32" height="26" rx="4"/><path d="M5 13h30M10 10h20"/>',
      watchcase: '<rect x="9" y="8" width="22" height="24" rx="7"/><path d="M15 3h10v5H15zm0 29h10v5H15z"/>',
      'wireless-holder': '<path d="M10 10v18h20V10M20 28v8M12 36h16M16 12q4-4 8 0M13 8q7-7 14 0"/>',
      screenbundle: '<rect x="10" y="5" width="20" height="30" rx="3"/><path d="M15 10h10M17 30h6"/>'
    };
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 40 40');
    svg.setAttribute('class', 'il-qn-icon');
    svg.setAttribute('aria-hidden', 'true');
    svg.innerHTML = paths[key] || paths.accessories;
    return svg;
  }
  // Batch 17 (test): optioneel extra carrouselitem uit [data-qn-extra], alleen voor een toestel waarvoor het thema
  // een gevulde collectie heeft opgegeven; nooit dubbel (zelfde type of zelfde URL).
  function withExtra(device, list) {
    try {
      const el = document.querySelector('[data-qn-extra]');
      const extra = el && JSON.parse(el.textContent)[device];
      if (!extra || !Array.isArray(list)) return list;
      if (list.some(e => e[2] === extra[2] || e[0].split('?')[0] === extra[0].split('?')[0])) return list;
      return list.concat([extra]);
    } catch (_) { return list; }
  }
  async function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'loading';
    try {
      const config = JSON.parse(root.querySelector('[data-qn-config]').textContent);
      const record = config.category ? ['', '', config.category.entries, false] : await read(config, root.dataset.collection);
      if (!record) return;
      let entries = record[2];
      if (!config.category && record[0]) {
        const family = await read(config, '@' + record[0]);
        if (family) entries = choose(withExtra(record[0], family[2]), record[1]);
      }
      const device = new URLSearchParams(location.search).get('device');
      // A context is valid only if its existing model page links to this exact collection.
      if (!config.category && device && /^[a-z0-9-]{1,120}$/.test(device)) {
        const model = await read(config, '@' + device);
        const modelList = model ? withExtra(device, model[2]) : null;
        if (modelList && modelList.some(e => e[0].split('?')[0] === '/collections/' + root.dataset.collection)) entries = choose(modelList, record[1]);
      }
      if (entries.length < 2) return;
      const list = root.querySelector('[data-qn-list]');
      const seenTypes = new Set();
      const seenImages = new Set();
      for (const [href, label, key, group, categoryImage] of entries) {
        if (seenTypes.has(key) || !/^\/(collections|pages)\/[a-z0-9-]+(?:\?device=[a-z0-9-]+)?$/.test(href)) continue;
        seenTypes.add(key);
        const item = document.createElement('li');
        const a = document.createElement('a');
        a.className = 'il-qn-chip'; a.href = href;
        if (href.split('?')[0] === '/collections/' + root.dataset.collection) {
          a.classList.add('is-current'); a.setAttribute('aria-current', 'page');
        }
        const src = categoryImage || config.images[key];
        if (src && !seenImages.has(src)) {
          seenImages.add(src);
          const img = document.createElement('img');
          const url = new URL(src); url.searchParams.set('width', '96');
          img.src = url.href; img.width = 40; img.height = 40; img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
          img.addEventListener('error', () => img.replaceWith(icon(key)), {once: true});
          a.append(img);
        } else a.append(icon(key));
        const span = document.createElement('span'); span.textContent = label; a.append(span);
        item.append(a); list.append(item);
      }
      const section = root.closest('.shopify-section');
      section?.querySelectorAll('.il-family-nav').forEach(el => { el.hidden = true; });
      if (record[3]) root.querySelector('[data-qn-title]').textContent = 'Navigeer snel · shop per categorie';
      root.hidden = false;
      root.dataset.ready = 'true';
      const prev = root.querySelector('[data-qn-prev]'), next = root.querySelector('[data-qn-next]');
      const update = () => { prev.disabled = list.scrollLeft < 3; next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 3; };
      const move = n => list.scrollBy({left: n * Math.max(180, list.clientWidth * .8), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      prev.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
      list.addEventListener('scroll', update, {passive: true});
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(list);
      update();
    } catch (_) {
      root.dataset.ready = 'unavailable'; // Existing collection links remain usable.
    }
  }
  document.querySelectorAll('[data-il-quick-nav]').forEach(setup);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-il-quick-nav]').forEach(setup));
})();

